import getPayeService from '../../../api/envService'
import { PARAMETRE_ENDPOINT } from '../../../api/endpoints'
import { setLoader } from '../loader-action'
import { SET_PARAMETRES } from '../../reducers/fonction/parametre-reducer'

export const setParametres = models => {
  return { type: SET_PARAMETRES, value: models }
}

export const getParametres = () => dispatch =>
  Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => getPayeService().get(PARAMETRE_ENDPOINT))
    .then(models => dispatch(setParametres(models)))
    .finally(() => dispatch(setLoader()))

export const createParametre = parametre => dispatch =>
  Promise.resolve()
    .then(() => getPayeService().post(PARAMETRE_ENDPOINT, parametre))
    .then(() => dispatch(getParametres()))
    .catch(e => {
      console.log(e)
    })

export const updateParametre = parametre => dispatch =>
  Promise.resolve()
    .then(() => getPayeService().put(PARAMETRE_ENDPOINT, parametre))
    .then(() => dispatch(getParametres()))
    .catch(e => {
      console.log(e)
    })

export const deleteParametre = nom => dispatch => {
  return Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => getPayeService().deleteById(PARAMETRE_ENDPOINT, nom))
    .then(() => dispatch(getParametres()))
    .finally(() => dispatch(setLoader(false)))
}
